import React__default from 'react';
import BoxWithIndicator from './BoxWithIndicator.js';
import { useCenterY } from './hooks/useCenterY.js';

/**
 * A RuleDetail renders a containing element that describes the details contained with a rule, and consists of a container and a caret that follows a rule as it progresses through a workflow
 */
const RuleDetail = ({
  children,
  side = 'left',
  hideArrow = false,
  testId,
  sx: sxProp
}) => {
  const {
    centerY
  } = useCenterY();
  return /*#__PURE__*/React__default.createElement(BoxWithIndicator, {
    side: side,
    hideArrow: centerY === null ? true : hideArrow,
    caretTop: centerY !== null && centerY !== void 0 ? centerY : undefined,
    testId: testId,
    sx: sxProp
  }, children);
};
RuleDetail.displayName = "RuleDetail";
RuleDetail.displayName = 'RuleDetail';

export { RuleDetail };
